var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_49_82)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.33301 7.9973V29.3234L10.6632 23.9919L21.3262 29.3234L30.6564 23.9919V2.66577L21.3262 7.9973L10.6632 2.66577L1.33301 7.9973Z",
    stroke: "current",
    strokeWidth: 1.99932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6611 2.66577V23.9919",
    stroke: "current",
    strokeWidth: 1.99932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3242 7.99719V29.3233",
    stroke: "current",
    strokeWidth: 1.99932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_49_82"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.9892,
    height: 31.9892,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.6b476435806ec92f39efb3e46a96cd23.svg";
export { ForwardRef as ReactComponent };